import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export const coachlyApi = {
  listCoaches: (params) => api.get("/coaches", { params }).then((r) => r.data),
  getCoach: (slug) => api.get(`/coaches/${slug}`).then((r) => r.data),
  createReview: (slug, payload) => api.post(`/coaches/${slug}/reviews`, payload).then((r) => r.data),
  replyToReview: (reviewId, payload) => api.post(`/reviews/${reviewId}/reply`, payload).then((r) => r.data),
  reportReview: (reviewId, payload) => api.post(`/reviews/${reviewId}/report`, payload).then((r) => r.data),
  joinWaitlist: (payload) => api.post("/waitlist", payload).then((r) => r.data),
};
